import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'dva';
import { Popup, Button, Toast } from 'antd-mobile-v5';
import moment from 'moment';
import { getCookie } from '@/utils/utils';
import { reportClick } from '@/utils/report';
import { jumpToPageByH5 } from '@/utils/fn';
import styles from './index.less';

const LEFT_SEC = 60;

const SmsVerify = ({
  auth: { phone },
  user: { accountCommonFields },
  dispatch,
  pageName,
  visible,
  onSubmit,
  onClose,
  smsType,
}) => {
  const inputRef = useRef();
  const timeRef = useRef();
  const [value, setValue] = useState('');
  const [numbers, setNumbers] = useState(['', '', '', '', '', '']);
  const [hasSendSms, setHasSendSms] = useState(false);
  const [leftSecond, setLeftSecond] = useState(60);
  const [smsToken, setSmsToken] = useState('');
  const [btnDisabled, setBtnDisabled] = useState(true);

  const handleOnClose = useCallback(() => {
    reportClick({
      page_name: pageName,
      button_name: 'close',
    });
    setValue('');
    setNumbers(['', '', '', '', '', '']);
    setBtnDisabled(true);
    onClose();
  }, [onClose, pageName]);

  const handleJumpToPage = useCallback(() => {
    reportClick({
      page_name: pageName,
      button_name: 'continue',
    });
    onSubmit(value, smsToken);
  }, [pageName, onSubmit, value, smsToken]);

  const handleChange = e => {
    const value = e.target.value;
    if (value.length > 6) return;
    // const { numbers } = this.state;
    numbers.forEach((item, index) => {
      numbers[index] = value[index] || '';
    });
    setValue(value);
    setNumbers(numbers.concat());
    if (value.length === 6) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  };

  const requestCode = useCallback(async () => {
    reportClick({
      page_name: pageName,
      button_name: 'verification_code',
    });
    // 清除实名发送短信验证码是通过v5账号系统发送的
    if (smsType === 'resultClear') {
      const params = JSON.parse(accountCommonFields);
      let userid = await getCookie('userid');
      let ak = await getCookie('sessionid');
      dispatch({
        type: 'auth/v5SmsSend',
        payload: {
          ...params,
          type: 36,
          userid,
          ak,
          timestamp: moment().valueOf(),
        },
        callback: data => {
          setSmsToken(data.tk);
          if (!hasSendSms) {
            setHasSendSms(true);
            setLeftSecond(LEFT_SEC);
          }
        },
      });
    } else if (smsType === 'personalBank') {
      // 个人银行卡认证发送短信验证码是通过v1 device系统发送的
      dispatch({
        type: 'auth/v1SmsSend',
        payload: { scene: 100 },
        callback: data => {
          if (!hasSendSms) {
            setHasSendSms(true);
            setLeftSecond(LEFT_SEC);
          }
        },
      });
    } else {
      Toast.show({
        content: '发送类型不包含',
      });
    }
  });

  useEffect(() => {
    if (hasSendSms) {
      timeRef.current = setTimeout(() => {
        if (leftSecond > 0) {
          setLeftSecond(leftSecond - 1);
        } else {
          setLeftSecond(0);
          setHasSendSms(false);
        }
      }, 1000);
    }
    return () => clearTimeout(timeRef.current);
  }, [hasSendSms, leftSecond]);

  return (
    <Popup
      visible={visible}
      onClose={handleOnClose}
      showCloseButton
      recordData
      bodyStyle={{
        borderTopLeftRadius: '0.4rem',
        borderTopRightRadius: '0.4rem',
      }}
    >
      <div>
        <div className={styles.smsVerifyPage}>
          <div className={styles.pleaseSms}>请输入短信验证码</div>
          <div className={styles.smsMessage}>
            <div className={styles.sendPhone}>{phone}</div>
            <Button disabled={hasSendSms} className={styles.smsBtn} onClick={requestCode}>
              {hasSendSms ? `重新发送(${leftSecond}s)` : '获取验证码'}
            </Button>
          </div>
          <label className={styles.smsRow} htmlFor="sms-code-input">
            <input
              id="sms-code-input"
              step="1"
              ref={inputRef}
              type="number"
              className={styles.smsInput}
              value={value}
              onChange={handleChange}
            />
            {numbers.map((item, index) => (
              <span key={index} className={styles.smsItem}>
                {item}
              </span>
            ))}
          </label>
          <Button
            disabled={btnDisabled}
            className={styles.continueBtn}
            type="primary"
            onClick={handleJumpToPage}
          >
            继续
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default connect(({ auth, user }) => ({
  auth,
  user,
}))(SmsVerify);
